import createIcon from '../../createIcon';

/**
 * @component @name QrCode2
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMjFIMTNWMTlIMTVWMjFaTTEzIDE0SDExVjE5SDEzVjE0Wk0yMSAxMkgxOVYxNkgyMVYxMlpNMTkgMTBIMTdWMTJIMTlWMTBaTTcgMTJINVYxNEg3VjEyWk01IDEwSDNWMTJINVYxMFpNMTIgNUgxNFYzSDEyVjVaTTQuNSA0LjVWNy41SDcuNVY0LjVINC41Wk05IDlIM1YzSDlWOVpNNC41IDE2LjVWMTkuNUg3LjVWMTYuNUg0LjVaTTkgMjFIM1YxNUg5VjIxWk0xNi41IDQuNVY3LjVIMTkuNVY0LjVIMTYuNVpNMjEgOUgxNVYzSDIxVjlaTTE5IDE5VjE2SDE1VjE4SDE3VjIxSDIxVjE5SDE5Wk0xNyAxMkgxM1YxNEgxN1YxMlpNMTMgMTBIN1YxMkg5VjE0SDExVjEySDEzVjEwWk0xNCA5VjdIMTJWNUgxMFY5SDE0Wk02Ljc1IDUuMjVINS4yNVY2Ljc1SDYuNzVWNS4yNVpNNi43NSAxNy4yNUg1LjI1VjE4Ljc1SDYuNzVWMTcuMjVaTTE4Ljc1IDUuMjVIMTcuMjVWNi43NUgxOC43NVY1LjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QrCode2 = createIcon('QrCode2', [
  [
    'path',
    {
      d: 'M15 21H13V19H15V21ZM13 14H11V19H13V14ZM21 12H19V16H21V12ZM19 10H17V12H19V10ZM7 12H5V14H7V12ZM5 10H3V12H5V10ZM12 5H14V3H12V5ZM4.5 4.5V7.5H7.5V4.5H4.5ZM9 9H3V3H9V9ZM4.5 16.5V19.5H7.5V16.5H4.5ZM9 21H3V15H9V21ZM16.5 4.5V7.5H19.5V4.5H16.5ZM21 9H15V3H21V9ZM19 19V16H15V18H17V21H21V19H19ZM17 12H13V14H17V12ZM13 10H7V12H9V14H11V12H13V10ZM14 9V7H12V5H10V9H14ZM6.75 5.25H5.25V6.75H6.75V5.25ZM6.75 17.25H5.25V18.75H6.75V17.25ZM18.75 5.25H17.25V6.75H18.75V5.25Z',
      key: '1r06rh',
    },
  ],
]);

export default QrCode2;
